import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  documentResourceResponseSchema,
  emptyObjectResponseSchema,
} from './common-responses';
import { editorStateSchema } from './editor-state';

export const documentUpdateBodyV20260601Schema = z.object({
  editorState: editorStateSchema
    .optional()
    .describe(
      'Updated TipTap document body. Omit to keep the current editor state.'
    ),
  description: z
    .string()
    .optional()
    .describe('Updated document description shown in the resource list.'),
  writtenAt: z
    .string()
    .optional()
    .describe(
      'ISO 8601 timestamp of when the document content was last authored (for display/sorting).'
    ),
});

export type DocumentUpdateBody = z.infer<
  typeof documentUpdateBodyV20260601Schema
>;

export const documentCreateBodyV20260601Schema = z.object({
  editorState: editorStateSchema,
  folderId: z
    .string()
    .uuid()
    .optional()
    .describe(
      'Optional folder UUID to place the new document in. When omitted, the document is created in the caller organization root.'
    ),
});

export type DocumentCreateBody = z.infer<
  typeof documentCreateBodyV20260601Schema
>;

export class DocumentUpdateV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'document-update-2026-06-01' as const;

  readonly name = DocumentUpdateV20260601Schema.version;
  readonly schema = documentUpdateBodyV20260601Schema;
  readonly response = emptyObjectResponseSchema;
}

export class DocumentCreateV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'document-create-2026-06-01' as const;

  readonly name = DocumentCreateV20260601Schema.version;
  readonly schema = documentCreateBodyV20260601Schema;
  readonly response = documentResourceResponseSchema;
}

export const DOCUMENT_API_SCHEMAS = [
  DocumentUpdateV20260601Schema,
  DocumentCreateV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
